import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './ForgotPassword.css';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const { forgotPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      await forgotPassword(email);
      setMessage('Verifique seu email para instruções de recuperação de senha');
    } catch (error) {
      console.error('Erro ao resetar senha:', error);
      setError('Não foi possível enviar o email de recuperação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-form-container">
          <div className="forgot-password-form-header">
            <img src="/assets/images/logo.png" alt="Logo Biblioteca MD Ensino" width="96" height="96" />
            <h1>Biblioteca MD Ensino</h1>
          </div>
          
          <h2>Recuperar Senha</h2>
          
          {error && <div className="error">{error}</div>}
          {message && <div className="success">{message}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                placeholder="Seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Email de Recuperação'}
            </button>

            <div className="links">
              <Link to="/login">Voltar para Login</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 